<template>
  <div>
    <TopBar title="Musiques" :cart="false"/>
    <div class="page-content ">
      <div class="container">
        <div class="serach-area">
          <form>
            <div class="mb-3 input-group input-radius">
						  <span class="input-group-text">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M20.5605 18.4395L16.7528 14.6318C17.5395 13.446 18 12.0262 18 10.5C18 6.3645 14.6355 3 10.5 3C6.3645 3 3 6.3645 3 10.5C3 14.6355 6.3645 18 10.5 18C12.0262 18 13.446 17.5395 14.6318 16.7528L18.4395 20.5605C19.0245 21.1462 19.9755 21.1462 20.5605 20.5605C21.1462 19.9748 21.1462 19.0252 20.5605 18.4395ZM5.25 10.5C5.25 7.605 7.605 5.25 10.5 5.25C13.395 5.25 15.75 7.605 15.75 10.5C15.75 13.395 13.395 15.75 10.5 15.75C7.605 15.75 5.25 13.395 5.25 10.5Z" fill="#B9B9B9"/>
                </svg>
              </span>
              <input v-model="research" type="text" class="form-control main-in ps-0 bs-0">
            </div>
          </form>
        </div>
        <ul class="dz-list message-list">
          <Musique v-for="(musique,index) in filteredMusiques"
                   :musique="musique"
                   :key="index"
                   :index="index" />
        </ul>
      </div>
      <br><br><br>
    </div>
  </div>
</template>

<script setup>


import {computed, ref} from "vue";
import {useStore} from "vuex";
import Musique from "@/components/musique";
import TopBar from "@/views/master/layouts/partials/TopBar";
const store = useStore()
const research = ref('')

const musiques = computed(() => store.getters['musique/musiques'])
const filteredMusiques = computed(() => {
  let search = research.value.toUpperCase()
  if(search && musiques.value.length > 0){
    return musiques.value.filter(musique => {
      let term = musique.title.toUpperCase() || musique.author.toUpperCase()
      if(term.indexOf(search) != -1){
        return musique
      }
    })
  }else {
    return musiques.value
  }
})

</script>
<style scoped>
.input-radius .form-control, .input-radius .input-group-text{
  border-radius: 10px;
}
.item-box .item-media img{
  height: 105px;
  width: 100%;
  object-fit: cover;
}
.page-content{
  max-height: 100vh;
  overflow-y: scroll;
}
</style>